import React from 'react';
import Icon from '../../../components/AppIcon';


const QuizHeader = ({ 
  currentQuestion, 
  totalQuestions, 
  xpAtStake, 
  timeRemaining, 
  onExit,
  isFullscreen,
  onToggleFullscreen,
}) => {
  const progress = (currentQuestion / totalQuestions) * 100;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  return (
    <div className="bg-card border-b border-border p-3 sm:p-4 md:p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-3 sm:mb-4 gap-2">
          {/* Left: Exit + question count */}
          <div className="flex items-center gap-2 sm:gap-3 min-w-0">
            <button
              onClick={onExit}
              aria-label="Exit quiz"
              className="flex items-center gap-1.5 px-3 py-2.5 rounded-lg text-sm font-medium text-muted-foreground hover:bg-muted active:scale-95 transition-all touch-manipulation"
              style={{ minHeight: '44px', minWidth: '44px' }}
            >
              <Icon name="X" size={18} />
              <span className="hidden sm:inline">Exit</span>
            </button>
            <div className="h-5 w-px bg-border hidden sm:block" />
            <span className="text-xs sm:text-sm font-medium text-foreground whitespace-nowrap">
              <span className="hidden sm:inline">Question </span>
              {currentQuestion}/{totalQuestions}
            </span>
          </div>

          {/* Right: Timer, XP, Fullscreen */}
          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
            {timeRemaining !== null && (
              <div className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-warning/10 border border-warning/20">
                <Icon name="Clock" size={15} className="text-warning" />
                <span className="text-xs sm:text-sm font-semibold text-warning">
                  {formatTime(timeRemaining)}
                </span>
              </div>
            )}
            <div className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-secondary/10 border border-secondary/20">
              <Icon name="Zap" size={15} className="text-secondary" />
              <span className="text-xs sm:text-sm font-semibold text-secondary">
                {xpAtStake} XP
              </span>
            </div>
            {/* Fullscreen toggle */}
            <button
              onClick={onToggleFullscreen}
              aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
              className="flex items-center justify-center rounded-lg bg-muted hover:bg-muted/80 active:scale-95 transition-all touch-manipulation"
              style={{ minHeight: '44px', minWidth: '44px' }}
            >
              <Icon name={isFullscreen ? 'Minimize2' : 'Maximize2'} size={18} className="text-muted-foreground" />
            </button>
          </div>
        </div>

        {/* Progress bar */}
        <div className="relative">
          <div className="h-2 sm:h-2.5 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-primary to-secondary transition-all duration-500 ease-out"
              style={{ width: `${progress}%` }}
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
              aria-label={`Quiz progress: ${currentQuestion} of ${totalQuestions} questions completed`}
            />
          </div>
          {/* Dots — hide on very small screens when there are many questions */}
          <div className={`absolute -top-1 left-0 right-0 flex justify-between px-1 ${totalQuestions > 8 ? 'hidden sm:flex' : ''}`}>
            {Array.from({ length: totalQuestions }, (_, i) => (
              <div
                key={i}
                className={`w-3.5 h-3.5 sm:w-4 sm:h-4 rounded-full border-2 transition-all duration-300 ${
                  i < currentQuestion
                    ? 'bg-primary border-primary'
                    : i === currentQuestion - 1
                    ? 'bg-secondary border-secondary scale-125' :'bg-background border-muted'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizHeader;